import React from 'react'
import {findDOMNode} from "react-dom"
import GenericListModule from "../generic-list-module"

// @ts-ignore
import GenericListPreviewLayer from "./preview-layer/preview-layer"
import GenericListMasterHeader from "./header/master-header"
// @ts-ignore
import GenericListGroup from "./group/list-group"
// @ts-ignore
import GenericListHeaderPreviewLayer from "./header/preview-layer/header-preview-layer"

import ListItems from "./item/rows"

import {GlistWidthMode} from "../manager/columns-manager/const"
import ErrorBoundary from "../../../error-boundary";
import {GlistHeaderMode} from "../const";

type Props = {
    className?      : string

    module          : GenericListModule,

    bottomComponent?: any
    children?       : any
}

// const debug: string = "GenericList"
const debug: boolean = false

export default class GenericList extends React.Component<Props, any> {

    isAutoWidthMode: boolean
    readyToRender: boolean

    node: any

    constructor(props: Props) {
        super(props)

        this.isAutoWidthMode = props.module.widthMode === GlistWidthMode.AUTO

        this.readyToRender = !this.isAutoWidthMode

        debug && console.log(debug, "constructor() isAutoWidthMode=", this.isAutoWidthMode, "readyToRender", this.readyToRender)
    }

    componentDidMount(): void {
        this.node       = findDOMNode(this)
        this.props.module.registerComponent(this)
        gd.layout.on("change:widthMain",this.onWidthChanged,this)

        debug && console.log(debug, '    componentDidMount() node=', this.node)
        debug && console.log(debug, '    isAutoWidthMode=', this.isAutoWidthMode)
        debug && console.log(debug, '    readyToRender=', this.readyToRender)

        this.props.module.updateDefaultGroupHover()

        if (this.isAutoWidthMode && !this.readyToRender) {
            this.readyToRender = true

            // timeout is required to have actual parentNode.clientWidth
            // otherwise clientWidth is 0
            setTimeout(()=>{
                this.props.module.setParentWidth(this.node.parentNode.clientWidth)
            }, 0)
        }
    }

    componentDidUpdate(prevProps: Props, prevState: Props, snapshot: any): void {
        this.node = findDOMNode(this) // we need it by why ?

        // we passed a new glist module to the same glist render component
        if (prevProps.module !== this.props.module) {
            this.props.module.registerComponent(this)
            this.props.module.updateDefaultGroupHover()

            this.isAutoWidthMode = this.props.module.widthMode === GlistWidthMode.AUTO

            // this.readyToRender = false
            if (this.isAutoWidthMode) {
                this.props.module.setParentWidth(this.node.parentNode.clientWidth)

                // timeout is required to have actual parentNode.clientWidth
                // otherwise clientWidth is 0
                // setTimeout(()=>{
                //     this.props.module.setParentWidth(this.node.parentNode.clientWidth)
                // }, 0)
            }

        }

        debug && console.log(debug, 'componentDidUpdate', this.node)
    }

    componentWillUnmount(): void {
        this.props.module.destructor()
        gd.layout.off("change:widthMain",this.onWidthChanged,this)
    }

    onWidthChanged = (): void => {
        if (this.isAutoWidthMode) {
            this.props.module.setParentWidth(this.node.parentNode.clientWidth)
        } else {
            this.props.module.onWidthChanged()
        }
    }

    onScroll = (e: any): void => {
        //check if title is floating
        const isFloating: boolean = e.target.scrollLeft !== 0 && e.target.scrollLeft >= 0;

        gd.utils.Dom.toggleClass(this.node, "title-stick", isFloating)
    }

    renderNotGrouped() {
        const items = this.props.module.data.get();

        debug && console.log(debug, 'renderNotGrouped', items)

        return (
            <React.Fragment>
                <div className="ui5-glist-group open is-first" style={{width: this.props.module.columns.combinedWidth}}>
                    <ListItems module={this.props.module} items={items}/>
                </div>
            </React.Fragment>
        )
    }

    renderGrouped() {
        const groupedItems = this.props.module.data.get();

        debug && console.log(debug, 'renderGrouped', groupedItems)

        return (
            <React.Fragment>
                {_.map(groupedItems, (group: any, key: number) =>
                    <GenericListGroup key           = {group.groupByValue}
                                      module        = {this.props.module}
                                      groupByValue  = {group.groupByValue}
                                      isFirst       = {key === 0}/>)}

                {groupedItems.length === 0 &&
                    <div className="ui5-glist-group open is-first" style={{width: this.props.module.columns.combinedWidth}}>
                        <ListItems module={this.props.module}/>
                    </div>}
            </React.Fragment>
        )
    }

    render() {

        debug && console.log(debug, 'render() readyToRender=', this.readyToRender)

        // if auto width required and parent width is unknown then render anchor div just to have access to parent node
        if (!this.readyToRender) return <div/>

        const addHeaderPreviewLayer: boolean    = ![GlistHeaderMode.HIDDEN].includes(this.props.module.headerMode) && this.props.module.canChangeColumnsOrder
        const addListPreviewLayer: boolean      = this.props.module.canDndItems

        const showNotGrouped: boolean           = !this.props.module.groupBy
        const showGrouped: boolean              = !!this.props.module.groupBy

        let showMasterHeader: boolean         = (![GlistHeaderMode.MULTIPLE,GlistHeaderMode.HIDDEN].includes(this.props.module.headerMode) && showGrouped) || !_.get(this.props, 'module.groupBy.value', null)
        if (this.props.module.headerMode === GlistHeaderMode.HIDDEN) showMasterHeader = false // patch experimental vic

        const classes: string = Classes(this.props.module.skin.className, this.props.className, {
            'with-master-header': showMasterHeader
        })

        debug && console.log(debug, 'render', showGrouped, this.props.module.columns.getCombinedWidth())

        if (this.props.module.data.collection.isEmpty && this.props.module.noItemsRenderComponent) {
            return this.props.module.noItemsRenderComponent
        }

        return (
            <ErrorBoundary>
                <div className={classes} style={{width: this.props.module.columns.getCombinedWidth()}}>
                    {addHeaderPreviewLayer &&
                        <GenericListHeaderPreviewLayer dndLayerName="genericListHeaderPreview" dndManager={this.props.module.headerDndManager} module={this.props.module}/>}

                    {addListPreviewLayer &&
                        <GenericListPreviewLayer dndLayerName="genericListPreview" dndManager={this.props.module.dndManager} module={this.props.module}/> }

                    {showMasterHeader &&
                        <GenericListMasterHeader module={this.props.module}/> }

                    {showNotGrouped && this.renderNotGrouped()}
                    {showGrouped && this.renderGrouped()}

                    {this.props.bottomComponent && <this.props.bottomComponent module={this.props.module}/>}

                    {this.props.children}

                    {this.props.module.displayGlistBottom && <div className="glist-bottom"/> }
                </div>
            </ErrorBoundary>
        )
    }
}
